import PropTypes from 'prop-types';
import { DangerousHtmlContent, NotificationPanel } from '@eti/components';
import { useTranslation } from '@eti/providers';
import { css, mediaQueries } from '@eti/styles';
import { TripCharacteristics } from '@eti/types';
import { constants } from '@eti/utils';
import { VIRTUAL_INTERLINING } from '../../../../constants/tripCharacteristics';
import ReadMore from '../../../../common/components/ReadMore';

const stackedIconStyles = css`
  height: 2rem;
  width: 2rem;

  @media ${mediaQueries.medium.down} {
    height: 1.5rem;
    width: 1.5rem;
  }
`;

const SelfTransferGuaranteeNotification = ({ tripCharacteristics, dataTestId }) => {
  const { t } = useTranslation();

  return tripCharacteristics.includes(VIRTUAL_INTERLINING) ? (
    <NotificationPanel
      className="etiNotification"
      dataTestId={dataTestId}
      icons={[
        { id: 'circle', size: '3rem', color: '#0c7e00' },
        { id: 'self-transfer', color: '#fff', className: stackedIconStyles },
      ]}
      title={t('SelfTransfer.InformationBox.Header.Text')}
      type={constants.notificationTypes.SELF_TRANSFER_GUARANTEE}
    >
      <ReadMore>
        <DangerousHtmlContent content={t('SelfTransfer.InformationBox.Content.Text')} />
      </ReadMore>
    </NotificationPanel>
  ) : null;
};

SelfTransferGuaranteeNotification.propTypes = {
  dataTestId: PropTypes.string,
  tripCharacteristics: PropTypes.arrayOf(TripCharacteristics),
};

export default SelfTransferGuaranteeNotification;
